<template>
    <fieldset :disabled="busy">
        <template v-for="field in parsedFields">
            <template v-if="field.type === 'row'">
                <form-row v-model="model" v-bind="field"></form-row>
            </template>
            <template v-else>
                <form-field v-model="model[field.name]" :errors="errors" v-bind="field"></form-field>
            </template>
        </template>
    </fieldset>
</template>

<script>
import FormRow from './FormRow';
import FormField from './FormField';
import Errors from '../forms/Errors';

export default {
    name: 't-form-fields',
    components: { FormField, FormRow },
    props: {
        fields: {
            required: true,
        },
        value: {
            required: false,
        },
        busy: {
            default: false,
        },
    },
    data: () => ({
        model: {
            errors: new Errors(),
        },
        errors: {},
        parsedFields: {},
    }),
    created() {
        // abbreviated version {name: type, name: type}
        if (!_.isArray(this.fields)) {
            this.parsedFields = _.map(this.fields, (type, name) => {
                if (_.isString(type)) {
                    return {
                        name: name,
                        type: type,
                        label: _.startCase(_.toLower(name)),
                    };
                }

                type['name'] = name;

                return type;
            });
        } else {
            this.parsedFields = this.fields;
        }
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newVal) {
                this.model = newVal ? newVal : {};
                this.errors = _.get(newVal, 'errors', new Errors());
            },
        },
        model: {
            deep: true,
            handler(newVal) {
                this.$emit('input', newVal);
            },
        },
    },
};
</script>
